import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import logo from './../assets/images/logo.png';

export default class CarbN6G extends Component {
  render() {
    return (
      <div className="container my-4 notification-100">

        <header className="text-center">
          <img src={logo} alt="KREP" style={{ borderRadius: '8px' }} />
          <h1 className="mt-2">Carb N 6G </h1>
        </header>

        {/* English Section */}
        <div className="section">
          <h3>English</h3>
          <ul>
            <li><span className="label">1. Gazette Notification number and Date:</span> S.O.3648 (E) Dated 13-08-2025</li>
            <li><span className="label">2. Title of Biostimulant:</span> (11) Mixture of Seaweed extract, Protein hydrolysate and Humic acid (Granule)</li>
            <li><span className="label">3. Composition:</span>
              <ul>
                <li>(i) Seaweed extract (Ascophyllum nodosum) per cent. by weight, maximum: 0.5</li>
                <li>(ii) Protein hydrolysate derived from defatted soy flour by enzymatic (papain) hydrolysis per cent. by weight, minimum: 0.5</li>
                <li>(iii) Humic acid (source: Leonardite) per cent. by weight, minimum: 0.02</li>
                <li>(iv) Polysorbate 80 per cent. by weight, minimum: 0.05</li>
                <li>(v) Bentonite granules per cent. by weight: QS</li>
                <li>(vi) Total (per cent.): 100.0</li>
              </ul>
            </li>
            <li><span className="label">4. Crops:</span> Onion, Paddy and Potato</li>
            <li><span className="label">5. Doses:</span>
              <ul>
                <li>(i) Onion: Two soil applications at 10 kg/ha</li>
                <li>(ii) Paddy: Two soil applications at 10 kg/ha</li>
                <li>(iii) Potato: Two soil applications at 10 kg/ha</li>
              </ul>
            </li>
          </ul>
        </div>

        {/* Hindi Section */}
        <div className="section">
          <h3>हिन्दी</h3>
          <ul>
            <li><span className="label">1. राजपत्र अधिसूचना संख्या एवं दिनांक:</span> एस.ओ.3648 (ई) दिनांक 13-08-2025</li>
            <li><span className="label">2. जैवउत्तेजक का शीर्षक:</span> (11) समुद्री शैवाल अर्क, प्रोटीन हाइड्रोलाइज़ेट और ह्यूमिक अम्ल (ग्रेन्यूल) का मिश्रण</li>
            <li><span className="label">3. संरचना:</span>
              <ul>
                <li>(i) समुद्री शैवाल अर्क (एस्कोफिलम नोडोसम) भार के अनुसार प्रतिशत, अधिकतम: 0.5</li>
                <li>(ii) एंजाइमी (पपेन) हाइड्रोलिसिस द्वारा वसा रहित सोया आटे से प्राप्त प्रोटीन हाइड्रोलाइज़ेट भार के अनुसार प्रतिशत, न्यूनतम: 0.5</li>
                <li>(iii) ह्यूमिक अम्ल (स्रोत: लियोनार्डाइट) भार के अनुसार प्रतिशत, न्यूनतम: 0.02</li>
                <li>(iv) पॉलीसोर्बेट 80 भार के अनुसार प्रतिशत, न्यूनतम: 0.05</li>
                <li>(v) बेंटोनाइट ग्रैन्यूल्स भार के अनुसार प्रतिशत: QS</li>
                <li>(vi) कुल (प्रतिशत): 100.0</li>
              </ul>
            </li>
            <li><span className="label">4. फसल:</span> प्याज, धान और आलू</li>
            <li><span className="label">5. मात्रा:</span>
              <ul>
                <li>(i) प्याज: 10 किग्रा/हेक्टेयर की दर से दो बार मिट्टी में मिलाना</li>
                <li>(ii) धान: 10 किग्रा/हेक्टेयर की दर से दो बार मिट्टी में मिलाना</li>
                <li>(iii) आलू: 10 किग्रा/हेक्टेयर की दर से दो बार मिट्टी में मिलाना</li>
              </ul>
            </li>
          </ul>
        </div>

        {/* Marathi Section */}
        <div className="section">
          <h3>मराठी</h3>
          <ul>
            <li><span className="label">१. राजपत्र अधिसूचना क्रमांक आणि तारीख:</span> एस.ओ.३६४८ (ई) दिनांक १३-०८-२०२५</li>
            <li><span className="label">२. बायोस्टिम्युलंटचे शीर्षक:</span> (११) समुद्री शैवाल अर्क, प्रथिने हायड्रोलायसेट आणि ह्युमिक अॅसिड (ग्रॅन्युल) यांचे मिश्रण</li>
            <li><span className="label">३. रचना:</span>
              <ul>
                <li>(i) समुद्री शैवाल अर्क (एस्कोफिलम नोडोसम) टक्के. वजनाने, कमाल: ०.५</li>
                <li>(ii) एंजाइमॅटिक (पॅपेन) हायड्रोलायसद्वारे डिफॅटेड सोया पीठापासून मिळवलेले प्रोटीन हायड्रोलायसेट टक्के. वजनाने, किमान: ०.५</li>
                <li>(iii) ह्युमिक अॅसिड (स्रोत: लिओनार्डाइट) टक्के. वजनाने, किमान: ०.०२</li>
                <li>(iv) पॉलिसोर्बेट ८० टक्के. वजनाने, किमान: ०.०५</li>
                <li>(v) बेंटोनाइट ग्रॅन्यूल्स टक्के. वजनानुसार: QS</li>
                <li>(vi) एकूण (टक्के): १००.०</li>
              </ul>
            </li>
            <li><span className="label">४. पीक:</span> कांदा, भात आणि बटाटा</li>
            <li><span className="label">५. मात्रा:</span>
              <ul>
                <li>(i) कांदा: १० किलो/हेक्टर दराने मातीचे दोन वापर</li>
                <li>(ii) भात: १० किलो/हेक्टर दराने मातीचे दोन वापर</li>
                <li>(iii) बटाटा: १० किलो/हेक्टर दराने मातीचे दोन वापर</li>
              </ul>
            </li>
          </ul>
        </div>

      </div>
    );
  }
}
